Bingo.DashboardCustomer = {};
Bingo.DashboardCustomer.PersonSelect = {};
Bingo.DashboardCustomer.PersonSelect.init = ($container) => {
    $container.find('.js-customerDropdown [data-customer]').on('click', function (e) {
        e.preventDefault();
        const customerId = $(this).attr('data-customer');

        $container.find('.js-customerDropdown-value').text($(this).text());
        $container.find('.js-customerDropdown [data-customer].-active').removeClass('-active');
        $container.find(`.js-customerDropdown [data-customer="${customerId}"]`).addClass('-active');
        $container.find('[data-for-customer]').hide();
        $container.find(`[data-for-customer="${customerId}"]`).show();
    });
};
Bingo.DashboardCustomer.TypeFilter = {};
Bingo.DashboardCustomer.TypeFilter.init = () => {
    // Change filter status
    $(document).on('click', '.js-typeFilter__dropdownMenu .js-filterTag', function (e) {
        e.preventDefault();
        $('.js-typeFilter__dropdownMenu .js-filterTag').removeClass('-active d-none d-lg-inline-block');
        $(this).addClass('-active d-none d-lg-inline-block');
        if ($(this).hasClass('-withCircle')) {
            $('.js-filterButton').addClass('-withCircle');
        } else {
            $('.js-filterButton').removeClass('-withCircle');
        }
        $('.js-filterButton').html($(this).html()).attr('data-filter-state', $(this).attr('data-filter-state'));
        const url = $(this).attr('data-filter-url');
        const typeId = $(this).data('typeid');
        $.nette.ajax({
            type: 'GET',
            url,
            data: {
                typeId,
            },
        });
    });
};
Bingo.DashboardCustomer.GridFilter = {};
Bingo.DashboardCustomer.GridFilter.init = ($filterButton) => {
    const $preview = $filterButton.closest('.js-preview');
    const $toggler = $preview.find('.js-preview__tableToggler');
    const gridId = $filterButton.data('gridId');

    $filterButton.on('click', () => {
        $preview.find('[data-grid-for]').hide();
        $preview.find(`[data-grid-for="${gridId}"]`).show();

        $preview.find('.js-grid-filter').removeClass('bg-blue-light');
        $filterButton.addClass('bg-blue-light');

        if (!$toggler.hasClass('-active')) {
            $toggler.trigger('click');
        }
    });
};
